import { Button, Input, Modal, Spin, Typography } from "antd";
import Title from "antd/es/typography/Title";
import React, { useEffect, useState } from "react";
import { ADD_STATUS_INITIAL_OBJECT } from "./StatusManagementUtils";
import { StatusManagementAPI } from "../../../API/admin/StatusManagementAPI";
const { Text } = Typography;

function EditStatus({ open, setOpen, messageToast, loadConfigData, editData }) {
  const [inputElements, setInputElements] = useState(ADD_STATUS_INITIAL_OBJECT);
  const [loadSpin, setLoadSpin] = useState(false);

  function backFun() {
    setInputElements(ADD_STATUS_INITIAL_OBJECT);
    setOpen(false);
  }

  function handleChange(value, name) {
    let error = "";

    if (!value.trim()) {
      error = "Field is required";
    } else if (value.trim().length >= 100) {
      error = "MAX length 100!";
    }

    setInputElements((prev) => ({
      ...prev,
      [name]: value,
      errorFieds: {
        ...prev.errorFieds,
        [name]: error,
      },
    }));
  }

  async function addFun() {
    if (formValidation()) {
      setLoadSpin(true);
      const bodyData = {
        name: inputElements.name,
      };
      await StatusManagementAPI.updateStatus(editData?.id, bodyData)
        .then((res) => {
          if (res.data.status === true) {
            setOpen(false);
            setLoadSpin(false);
            setInputElements(ADD_STATUS_INITIAL_OBJECT);
            messageToast("success", res.data?.message);
            loadConfigData();
          } else {
            messageToast("error", res.data?.message);
            setLoadSpin(false);
          }
        })
        .catch(() => {
          messageToast("error", "Internal Server Error");
          setLoadSpin(false);
        });
    }
  }

  function formValidation() {
    let isValid = false;
    let obj = { ...inputElements };

    obj.errorFieds = {
      ...inputElements.errorFieds,
      name: !inputElements.name
        ? "Field is required"
        : inputElements.name.trim().length >= 100
          ? "MAX length 100!"
          : "",
    };

    setInputElements(obj);

    if (obj.name && !obj.errorFieds.name) {
      isValid = true;
    }

    return isValid;
  }

  useEffect(() => {
    if (open) {
      setInputElements({
        ...ADD_STATUS_INITIAL_OBJECT,
        name: editData.name,
      });
    }
  }, [open, editData]);

  return (
    <Modal
      open={open}
      okText="Apply"
      cancelText="Clear All"
      onCancel={() => backFun()}
      footer={[
        <Button key="back" type="text" onClick={backFun}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={addFun}>
          Save
        </Button>,
      ]}
    >
      <Spin spinning={loadSpin}>
        <div style={{ padding: "10px" }}>
          <div
            style={{
              marginBottom: "20px",
              borderBottom: "solid 1px #80808047",
            }}
          >
            <Title level={5}>Edit Status</Title>
          </div>

          <div style={{ gap: 10 }}>
            <div style={{ marginBottom: "15px" }}>
              <label>Name</label>
              <Input
                status={inputElements.errorFieds.name === "" ? "" : "error"}
                value={inputElements.name}
                onChange={(e) =>
                  handleChange(e.target.value.trimStart(), "name")
                }
              />
              <Text type="danger" italic>
                {inputElements.errorFieds.name}
              </Text>
            </div>
          </div>
        </div>
      </Spin>
    </Modal>
  );
}

export default EditStatus;
